import { useCallback, useRef, useState } from 'react';

// One request at a time for a dialog: `run(handler)` ignores a second click or Enter while the first is
// still waiting on the API, and `busy` tells the dialog's buttons to disable and show a spinner.
// The ref blocks at once; state alone would let a fast double tap through before the re-render.
const useBusy = () => {
    const running = useRef(false);
    const [busy, setBusy] = useState(false);
    const run = useCallback((handler) => async (event, ...rest) => {
        event?.preventDefault?.();
        if (running.current) return;
        running.current = true;
        setBusy(true);
        try {
            return await handler(event, ...rest);
        } finally {
            running.current = false;
            setBusy(false);
        }
    }, []);
    return [busy, run];
};

export default useBusy;
